import { Pipe, PipeTransform } from '@angular/core';
import { normalizeMatchScore } from './match-score-utils';

@Pipe({
  name: 'matchScorePercentage',
  standalone: true
})
export class MatchScorePercentagePipe implements PipeTransform {
  /**
   * Transform match score to normalized percentage display.
   *
   * Uses normalization to stretch the typical score range (0.4-0.95) to 0-100%
   * for better user comprehension. Raw scores typically cluster between 0.5-0.9,
   * making raw percentages less intuitive for users.
   *
   * @param score - Raw similarity score (0-1) or percentage (0-100)
   * @returns Formatted normalized percentage string (e.g., "58%" or "N/A")
   */
  transform(score: number | null | undefined): string {
    if (!score && score !== 0) return 'N/A';

    const normalized = normalizeMatchScore(score);
    return `${normalized}%`;
  }
}
